import { useHistory } from "react-router-dom";

import { ModelSearch } from "shared/components";

const ProductsUploadTile = () => {
    const history = useHistory();

    const handleClick = (model) => {
        history.push(`overstock/${model.SKU}/upload`);
    }

    return (
        <article className="tile is-child notification">
            <div className="content">
                <p className="title">Upload a batch</p>
                <p className="subtitle">Enter the SKU of the model</p>
                <div className="content">
                    <div className="field has-addons">
                        <div className="control is-expanded">
                            <ModelSearch id='product-upload' onClick={handleClick} />
                        </div>
                        <button className="button is-primary">Upload</button>
                    </div>
                </div>
            </div>
        </article >
    );
}

export { ProductsUploadTile };
